import React from 'react';
import { CgButtonContainer, CgButtonContent, CgButtonLoader } from './CgButton.styles.js';
import { Spinner } from '../Spinner/Spinner.js';
var ECgButtonSize;

(function (ECgButtonSize) {
  ECgButtonSize[ECgButtonSize["small"] = 0] = "small";
  ECgButtonSize[ECgButtonSize["medium"] = 1] = "medium";
  ECgButtonSize[ECgButtonSize["large"] = 2] = "large";
})(ECgButtonSize || (ECgButtonSize = {}));

var EButtonVariant;

(function (EButtonVariant) {
  EButtonVariant[EButtonVariant["primary"] = 0] = "primary";
  EButtonVariant[EButtonVariant["secondary"] = 1] = "secondary";
  EButtonVariant[EButtonVariant["tertiary"] = 2] = "tertiary";
  EButtonVariant[EButtonVariant["prio"] = 3] = "prio";
  EButtonVariant[EButtonVariant["ghost"] = 4] = "ghost";
})(EButtonVariant || (EButtonVariant = {}));

var CgButton = function CgButton(_a) {
  var size = _a.size,
      variant = _a.variant,
      icon = _a.icon,
      flexReverse = _a.flexReverse,
      disabled = _a.disabled,
      _onClick = _a.onClick,
      children = _a.children,
      loading = _a.loading,
      fullWidth = _a.fullWidth,
      buttonRef = _a.buttonRef,
      round = _a.round,
      _b = _a.shouldPreventDefault,
      shouldPreventDefault = _b === void 0 ? true : _b;
  return React.createElement(CgButtonContainer, {
    ref: buttonRef,
    round: round,
    size: size,
    variant: variant,
    isIconOnly: !children,
    flexReverse: flexReverse,
    disabled: disabled || loading,
    fullWidth: fullWidth,
    loading: loading,
    onKeyDown: function onKeyDown(event) {
      if (event.key === 'Enter' && !disabled) {
        _onClick && _onClick();
      }
    },
    onClick: function onClick(e) {
      shouldPreventDefault && e.preventDefault();
      _onClick && _onClick();
    }
  }, React.createElement(CgButtonContent, {
    size: size,
    flexReverse: flexReverse,
    loading: loading
  }, icon, children), loading && React.createElement(CgButtonLoader, null, React.createElement(Spinner, {
    animationSpeedMs: 1000,
    size: 16
  })));
};

export { CgButton, EButtonVariant, ECgButtonSize };